var _defs, _style, _use;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinimize(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 87",
    width: 90,
    height: 87,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "minimize") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 90,
    height: 87,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABXAQMAAAC++MCfAAAAAXNSR0IB2cksfwAAAAZQTFRFMD6B////6ldPyQAAACpJREFUeJxjZEACjLg58g9gzP9Mo5xRzjDl/OSAsKnDGXj/0IfDgARwcwBd+K5Yi9jgEwAAAABJRU5ErkJggg=="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Background",
    href: "#img1",
    x: 0,
    y: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimize);
export default __webpack_public_path__ + "static/media/minimize.d8fb777d2e319387cbced52764724747.svg";
export { ForwardRef as ReactComponent };